<div class="modalClose">
  <img src="/assets/img/shared/close.svg" (click)="closeModal()" />
</div>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-title class="smaller overskrift">
          <h1>Kontakt oss</h1>
        </ion-title>
      </ion-col>
    </ion-row>
    <ion-row class="mi-3">
      <ion-col>
        <a href="mailto:kunde@ishavskraft.no">
          <ion-button class="dark-primary wide round" size="large">
            <ion-icon name="mail-outline" class="mr-3"></ion-icon>
            Send oss e-post
          </ion-button>
        </a>
        <p (click)="copyEmail()" class="copytext">
          Kopiér e-postadresse <ion-icon name="copy-outline"></ion-icon>
        </p>
      </ion-col>
    </ion-row>
    <ion-row class="mi-3">
      <ion-col>
        <a href="tel:+4777612000">
          <ion-button class="wide secondary round" size="large">
            <ion-icon name="call-outline" class="mr-3"></ion-icon>
            Ring oss
          </ion-button>
        </a>
        <p (click)="copyPhone()" class="copytext">
          Kopiér telefonnummer <ion-icon name="copy-outline"></ion-icon>
        </p>
      </ion-col>
    </ion-row>
    @if (!callbackDisabled) {
    <ion-row class="mi-3">
      <ion-col>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="2"
          viewBox="0 0 344 2"
          fill="none"
        >
          <path
            d="M1 1H343"
            stroke="#002987"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
        @if (!showConfirm) {
        <div>
          <p class="bold text-left">Eller så kan vi ringe deg</p>
          @if (contactForm) {
          <form [formGroup]="contactForm" class="form-input-ihk form-container">
            <ion-input
              label="Mobilnummer"
              labelPlacement="stacked"
              placeholder="Telefon"
              formControlName="phone"
              fill="outline"
              errorText="Mobilnummer må ha minst 8 siffer"
            ></ion-input>
            <ion-input
              label="Navn"
              labelPlacement="stacked"
              placeholder="Ditt navn (Valgfri)"
              formControlName="name"
              fill="outline"
            ></ion-input>
            <ion-button
              class="dark-primary wide"
              (click)="sendContact()"
              [disabled]="!contactForm.valid"
              >Send inn</ion-button
            >
          </form>
          } @else {
          <div class="loadingContainer">
            <ion-spinner name="dots"></ion-spinner>
          </div>
          }
        </div>
        } @if (showConfirm) {
        <div>
          <p class="bold text-left">Vi ringer deg!</p>
          <p class="text-left">
            Takk for henvendelsen, vi kontakter deg på telefon
            {{ contactForm.value.phone || '' }} så snart en av våre
            kunderådgivere blir ledig!
          </p>
          <ion-button class="dark wide" (click)="closeModal()">Lukk</ion-button>
        </div>

        }
      </ion-col>
    </ion-row>
    }
  </ion-grid>
</ion-content>
